import {observable} from 'mobx';
import {Language} from './language';
import {SeoLocaleContent} from './seo-locale-content';
import {SeoAppLanguage} from './seo-app-language';
import {construct, createArrayInstance, createInstance, ModelProperties} from 'utils';

export class SeoApp {
    @observable id!: number;

    @observable name!: string;

    @observable targetLanguageId!: number;

    @observable content?: SeoLocaleContent[];

    @observable targetLanguage?: Language;

    @observable languages?: SeoAppLanguage[];

    constructor(app?: ModelProperties<SeoApp>) {
        if (app) {
            construct(this, app);
            this.content = createArrayInstance(SeoLocaleContent, app.content);
            this.languages = createArrayInstance(SeoAppLanguage, app.languages);
            this.targetLanguage = createInstance(Language, app.targetLanguage);
        }
    }
}